<template>
  <div class="coupon-setting-form">
    <!-- 隐藏的ID字段 -->
    <input type="hidden" v-model="form.id" />

    <!-- 渠道名称 -->
    <div class="q-mb-md row items-center">
      C端展示的渠道名称:
      <q-input v-model="form.C_NAME" placeholder="请输入渠道名称" outlined dense class="rs-size-sm q-ml-md" />
    </div>

    <!-- 线上渠道复选框 -->
    <q-checkbox
      v-model="form.SHOW_QR_CODE"
      true-value="1"
      false-value="0"
      label="在券详情中展示二维码"
      @update:model-value="onShowQrCodeChange"
      size="sm"
    />

    <!-- 线上渠道复选框 -->
    <q-checkbox
      v-if="form.TYPE === 'online'"
      v-model="form.DISPLAY"
      :true-value="true"
      :false-value="false"
      label="当该渠道为线上渠道时,将在C端出现前往使用"
      @update:model-value="onOnlineChannelChange"
      size="sm"
    />

    <!-- 点击前往使用后的交互选项 - 只有勾选线上渠道时才显示 -->
    <div v-if="form.DISPLAY" class="interaction-section">
      <div>点击"前往使用"后的交互:</div>

      <!-- 跳转小程序选项 -->
      <div>
        <div>
          <div class="row items-center">
            <q-radio
              v-model="form.MODE"
              val="APP"
              label="跳转小程序"
              @update:model-value="onInteractionTypeChange"
              class="radio-item"
            />
            <div class="text-caption text-negative q-ml-md">*当用券地点为商城小程序时</div>
          </div>
          <!-- 跳转小程序相关字段 -->
          <div v-show="form.MODE === 'APP'">
            <div class="q-mb-md row items-center">
              <span class="label-text">小程序APPID:</span>
              <q-input
                v-model="form.APPID"
                placeholder="请输入小程序APPID"
                outlined
                dense
                class="input-field q-ml-md rs-size-sm"
              />
            </div>
            <div class="q-mb-md row items-center">
              <span class="label-text">小程序页面地址:</span>
              <q-input
                v-model="form.APPURL"
                placeholder="请输入小程序页面地址"
                outlined
                dense
                class="input-field q-ml-md rs-size-sm"
              />
            </div>
          </div>
        </div>

        <div class="radio-item-container">
          <div class="row items-center">
            <q-radio
              v-model="form.MODE"
              val="POP"
              label="弹出弹窗"
              @update:model-value="onInteractionTypeChange"
              class="radio-item"
            />
            <div class="text-caption text-negative q-ml-md">*当用券地点为APP,PC官网等时</div>
          </div>
          <!-- 弹出弹窗相关字段 -->
          <div v-show="form.MODE === 'POP'">
            <div class="q-mb-md row items-start">
              <span class="label-text">弹窗文案:</span>
              <q-input
                v-model="form.POP_COPYWRITER"
                placeholder="请输入弹窗文案"
                type="textarea"
                outlined
                dense
                rows="4"
                class="input-field q-ml-md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="row justify-center q-gutter-md q-mt-lg position-absolute bottom-0 right-0">
      <q-btn color="primary" label="提交" @click="handleSubmit" :loading="submitting" />
    </div>
  </div>
</template>

<script>
import Config from "rsui-core/src/config";
import ModelService from "rsui-core/src/core/model-service";
import ApiService from "rsui-core/src/system/service/api";
export default {
  name: "CouponSetting",
  props: {
    defValue: {
      type: Object,
      default: () => ({}),
    },
    settingId: {
      type: [Number, String],
      default: "",
    },
    tenantId: {
      type: Number,
      default: null,
    },
    closeDialog: {
      type: Function,
    },
    refresh: {
      type: Function,
    },
    isSpecType: {
      type: Boolean,
    },
    isCouponMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      modelService: new ModelService(),
      submitting: false,
      form: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // this.form = { ...this.defValue };
      console.log(this.defValue.ext.CONFIG, "this.defValue.ext.CONFIG");

      // 如果 defValue 中有 CONFIG 字段，直接使用 CONFIG 的值
      if (this.defValue && this.defValue.ext && this.defValue.ext.CONFIG) {
        const config = this.defValue.ext.CONFIG;
        this.form = {
          // ...this.form,
          ...config,
          DISPLAY: config.DISPLAY || false,
          SHOW_QR_CODE: config.SHOW_QR_CODE || "1",
          C_NAME: config.C_NAME || this.form.C_NAME,
          TYPE: config.TYPE || this.form.TYPE,
          MODE: config.MODE || this.form.MODE,
          APPID: config.APPID || this.form.APPID,
          APPURL: config.APPURL || this.form.APPURL,
          POP_COPYWRITER: config.POP_COPYWRITER || this.form.POP_COPYWRITER,
        };
      }
    },
    onOnlineChannelChange(value) {
      // 当取消勾选线上渠道时，清空交互相关字段
      if (!value) {
        this.form.MODE = "";
        this.form.APPID = "";
        this.form.APPURL = "";
        this.form.POP_COPYWRITER = "";
      } else {
        // 默认选择弹出弹窗
        this.form.MODE = "POP";
        this.form.POP_COPYWRITER = "请前往该渠道使用优惠券";
      }
    },

    onShowQrCodeChange(value) {
      // if (!value) {
      //   this.form.QR_CODE = "";
      // }
    },

    onInteractionTypeChange(value) {
      // 切换交互类型时清空相关字段
      if (value === "APP") {
        this.form.POP_COPYWRITER = "";
      } else if (value === "POP") {
        this.form.APPID = "";
        this.form.APPURL = "";
        this.form.POP_COPYWRITER = "请前往该渠道使用优惠券";
      }
    },

    // 提交表单
    async handleSubmit() {
      // 表单验证
      if (!this.form.C_NAME.trim()) {
        this.$q.notify({
          type: "negative",
          message: "请输入渠道名称",
          position: "top",
        });
        return;
      }

      if (this.form.TYPE === "online") {
        if (!this.form.MODE) {
          this.$q.notify({
            type: "negative",
            message: "请选择交互类型",
            position: "top",
          });
          return;
        }

        if (this.form.MODE === "APP") {
          if (!this.form.APPID.trim()) {
            this.$q.notify({
              type: "negative",
              message: "请输入小程序APPID",
              position: "top",
            });
            return;
          }
          if (!this.form.APPURL.trim()) {
            this.$q.notify({
              type: "negative",
              message: "请输入小程序页面地址",
              position: "top",
            });
            return;
          }
        } else if (this.form.MODE === "POP") {
          if (!this.form.POP_COPYWRITER.trim()) {
            this.$q.notify({
              type: "negative",
              message: "请输入弹窗文案",
              position: "top",
            });
            return;
          }
        }
      }

      this.submitting = true;

      try {
        // 准备提交数据，直接使用 form 数据作为 CONFIG
        const submitData = {
          ...this.form,
          // CONFIG: {
          //   C_NAME: this.form.C_NAME,
          //   TYPE: this.form.TYPE,
          //   MODE: this.form.MODE,
          //   APPID: this.form.APPID,
          //   APPURL: this.form.APPURL,
          //   POP_COPYWRITER: this.form.POP_COPYWRITER
          // }
        };

        // 提交数据
        console.log("提交的表单数据:", submitData);

        // 这里可以添加实际的提交逻辑，比如调用API
        // await this.submitToServer();

        const postParams = {
          ...this.defValue,
          setting: { id: this.settingId },
          tenant: { id: this.tenantId },
          ext: { ...this.defValue.ext, CONFIG: submitData },
        };
        if ((this.isSpecType || this.isCouponMode) && this.defValue.sysReserved) {
          postParams.id = null;
        }
        await this.$rs_post(Config.API.TEN_MODULE_SETTING_DETAIL_CREATE_OR_UPDATE, postParams);
        this.$q.notify({
          type: "positive",
          message: "提交成功！",
          position: "top",
        });
        this.closeDialog();
        this.refresh();
      } catch (error) {
        // this.$q.notify({
        //   type: 'negative',
        //   message: '提交失败，请重试',
        //   position: 'top'
        // });
      } finally {
        this.submitting = false;
      }
    },

    // 重置表单
    handleReset() {
      this.form = {
        id: null,
        C_NAME: "",
        SHOW_QR_CODE: "1",
        TYPE: "offline",
        MODE: "",
        APPID: "",
        APPURL: "",
        POP_COPYWRITER: "",
      };
    },
  },
};
</script>

<style scoped>
.coupon-setting-form {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.interaction-section {
  margin-top: 20px;
  padding: 16px;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.radio-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.radio-item-container {
  display: flex;
  flex-direction: column;
}

.radio-item {
  display: flex;
  align-items: center;
}

.radio-content {
  margin-left: 24px;
  margin-top: 8px;
  padding: 12px;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.label-text {
  min-width: 120px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.input-field {
  flex: 1;
  max-width: 300px;
}
</style>
